<template>
  <SettingsPageFull>
    <template #title>
      <div class="flex space-x-3">
        <font-awesome-icon :icon="['fal', 'list']" size="2x" />
        <span class="text-2xl font-bold capitalize-first">
          {{ $t('navigation.list_item_title') }}
        </span>
      </div>
    </template>
    <template #body>
      <div class="flex flex-col gap-4">
        <div class="flex justify-end">
          <div class="w-96 max-sm:w-full">
            <BaseSearchInput
              v-model="filterText"
              :placeholder="$t('global.search')"
            />
          </div>
        </div>
        <div
          class="flex flex-col divide-y divide-slate-200 rounded-md border border-slate-200 bg-white dark:divide-slate-600 dark:border-slate-600 dark:bg-slate-700"
        >
          <div
            v-for="groupName in filteredGroupNames"
            :key="groupName"
            class="flex flex-col gap-3 p-3"
          >
            <ListItemComponent
              :group-name="groupName"
              :list-items="listItemsByGroup[groupName]"
              :edition-mode="editionMode"
            />
          </div>
          <div
            v-if="!filteredGroupNames.length"
            class="p-6 text-center text-gray-500 italic"
          >
            {{ $t('global.no_result_found') }}
          </div>
        </div>
      </div>
    </template>
  </SettingsPageFull>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ListItemComponent from './components/ListItemComponent.vue'

/** The list items, by group, as FM's settings page: open a group to edit. */
export default {
  name: 'TheListItemIndexPage',
  components: { ListItemComponent },
  data() {
    return { filterText: '' }
  },
  computed: {
    ...mapGetters({ listItemsByGroup: 'itemList/getListItemsIndex' }),
    editionMode() {
      return this.$can('manage_content')
    },
    filteredGroupNames() {
      const term = this.$h.normalizeSearch(this.filterText)
      return Object.keys(this.listItemsByGroup ?? {})
        .filter(
          (group) =>
            !term ||
            this.$h
              .normalizeSearch(this.$t(`enums.listeItem.${group}`))
              .includes(term)
        )
        .sort((a, b) =>
          this.$t(`enums.listeItem.${a}`).localeCompare(
            this.$t(`enums.listeItem.${b}`)
          )
        )
    }
  },
  mounted() {
    this.fetchListItems()
  },
  methods: {
    ...mapActions({ fetchListItems: 'itemList/fetchListItems' })
  }
}
</script>
